import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty, isNil, pathOr } from 'ramda'
import { Loader, Div, P, Span, Button } from '@driftt/tide-core'
import HubspotLogo from '../HubspotLogo'
import { fetchHubSpotEnrichmentByEmail } from 'api/hubspotEnrichment'
import { fetchHubSpotEnrichmentStart, fetchHubSpotEnrichmentFailed, fetchHubSpotEnrichmentSuccess } from 'modules/hubspot/actions'

import './style.css'

class HubSpotSection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errorMessage: null
    }
  }
  
  componentDidMount(){
    this.enrich()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.email !== this.props.email) {
      this.enrich()
    }
  }

  enrich = async () => {
    const { email, fetchHubSpotEnrichmentStart, fetchHubSpotEnrichmentSuccess, fetchHubSpotEnrichmentFailed } = this.props

    fetchHubSpotEnrichmentStart(email)

    try {
      const { data } = await fetchHubSpotEnrichmentByEmail({ email })
      fetchHubSpotEnrichmentSuccess(data, email)

      this.setState({
        errorMessage: null
      })
    } catch(e) {
      console.warn(e)

      const errorMessage = e.response.status === 404
        ? "Couldn't find matching record in HubSpot"
        : "Error fetching data from HubSpot"

      this.setState({ errorMessage })
			fetchHubSpotEnrichmentFailed(e.response, email)
		}
  }

  get isLoading() {
    const isLoading = pathOr(false, ['hubSpotEnrichment', 'loading'], this.props)

    const noDataYet = isNil(this.props.hubSpotEnrichment)

    return isLoading || noDataYet
  }

  get isError() {
    const error = pathOr({}, ['hubSpotEnrichment', 'error'], this.props)

    return !isEmpty(error)
  }

  get hubspotData() {
    return pathOr(false, ['hubSpotEnrichment', 'data'], this.props)
  }
	
  renderHubSpotInfo = () => {
    const data = this.hubspotData
    const { contact } = data
    const { properties } = contact
    const emptyValue = { 'value': null }
    const contactOwner = pathOr(null, ['owner'], data)

    return (
      <Div>
        {renderRow("Contact Owner", pathOr(null, ['name'], contactOwner))}
        {renderRow("Lifecycle Stage", pathOr(emptyValue, ['lifecyclestage'], properties).value)}
        {renderRow("Lead Status", pathOr(emptyValue, ['hs_lead_status'], properties).value)}
        {renderRow("HubSpot Score", pathOr(emptyValue, ['cql_score'], properties).value)}
        {
          <Div className="sfdc-enrichment-body-row contacts-contact-sidebar--details--about-field">
            <Button type="subtle" href={pathOr(null, ['profileUrl'], contact)} target="_blank" className="view-in-hubspot-link">
              View in HubSpot
            </Button>
          </Div>
        }
      </Div>
    )
  }

  renderErrorState = () => {
    const { errorMessage } = this.state

    if (!this.isError) {
      return null
    }

    return <P className="hubspot-error-message">{errorMessage}</P>
  }

  render() {
    const loading = this.isLoading
    const error = this.isError

    return (
      <Div>
				<Div className="hubspot-section-header">
					<HubspotLogo className="header-icon" />
        	<Span className="hubspot-section-title">
          	HUBSPOT DETAILS
        	</Span>
				</Div>
      	<Div className="hubspot-section-body">
        	{ loading && <Loader /> }
        	{ error && this.renderErrorState() }
        	{ (!loading && !error) && this.renderHubSpotInfo() }
      	</Div>
    	</Div>
    )
  }
}

HubSpotSection.props = {
  email: String
}

const renderRow = (header, value) =>
  <Div className="contacts-contact-sidebar--details--about-field">
    <Div className="hubspot-enrichment-body-row">
      <Div className="hubspot-enrichment-row-header">
        {header}
      </Div>
      <Div className="hubspot-enrichment-row-body">
        {value ? value : "N/A"}
      </Div>
    </Div>
  </Div>

const mapStateToProps = () => {
  return (state, props) => {
    const { email } = props

    return {
      hubSpotEnrichment: state.__CRM.hubSpotEnrichment.enrichment[email]
    }
  }
}

const mapDispatchToProps = dispatch => ({
  fetchHubSpotEnrichmentStart: email => {
    dispatch(fetchHubSpotEnrichmentStart(email))
  },
  fetchHubSpotEnrichmentFailed: (email, err) => {
    dispatch(fetchHubSpotEnrichmentFailed(email, err))
  },
  fetchHubSpotEnrichmentSuccess: (email, data) => {
    dispatch(fetchHubSpotEnrichmentSuccess(email, data))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(HubSpotSection)
